import React from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  HeroContainer,
  LowerRowContainer,
  CommunityName,
  FirstRowContainer,
  CommunityStatus,
  InfoContainer,
  AvatarContainer,
  ContentContainer,
  CommunityBasic
} from './styled'

import coworking from 'assets/images/coworking.jpg'

const BookingHeader = ( { title, subtitle, background } ) => {

  if (background == null) {
    background = coworking
  }
  return (
    <Container>
      <HeroContainer elevation={0} background={background}>
        {/* Content for the Hero section */}
      </HeroContainer>

      <InfoContainer>
        <AvatarContainer></AvatarContainer>
        <ContentContainer>

          <LowerRowContainer>
            <FirstRowContainer>
              <CommunityBasic>
                <CommunityName>{title}</CommunityName>
                <CommunityStatus>{subtitle}</CommunityStatus>
              </CommunityBasic>

              {/* <JoinButton variant="contained" color="primary">Join</JoinButton> */}
            </FirstRowContainer>


          </LowerRowContainer>
        </ContentContainer>
      </InfoContainer>
    </Container>

  )
}

BookingHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  avatar: PropTypes.string,
  background: PropTypes.string
}

export default BookingHeader
